import { render, staticRenderFns } from "./SharePrayer.vue?vue&type=template&id=5fdce6b5&scoped=true&"
import script from "./SharePrayer.vue?vue&type=script&lang=js&"
export * from "./SharePrayer.vue?vue&type=script&lang=js&"
import style0 from "./SharePrayer.vue?vue&type=style&index=0&id=5fdce6b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdce6b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
